import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const MoreVertical = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M3.995 11.335v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1v-1.33a1.1 1.1 0 0 0-1.1-1.1h-1.33a1.1 1.1 0 0 0-1.1 1.1ZM10.225 11.335v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1v-1.33a1.1 1.1 0 0 0-1.1-1.1h-1.33a1.1 1.1 0 0 0-1.1 1.1ZM16.465 11.335v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1v-1.33a1.1 1.1 0 0 0-1.1-1.1h-1.33a1.1 1.1 0 0 0-1.1 1.1Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MoreVertical
